// components/ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useNavigation } from "../contexts/NavigationContext";
import { useNavigate } from "react-router-dom";
// import { useNavigation } from "../contexts/NavigationContext";

// const ProtectedRoute = ({ children }) => {
//   const { hasSubmittedVideo } = useNavigation();
//   const location = useLocation();

//   if (hasSubmittedVideo && location.pathname === "/record") {
//     return <Navigate to="/verification-success" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

// components/ProtectedRoute.js

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasValidToken = location.state?.token;
  const { hasSubmittedVideo } = useNavigation(); // Get this from your NavigationContext

  // Handle verification success page specially
  if (location.pathname === "/verification-success") {
    if (!hasSubmittedVideo) {
      return <Navigate to="/" replace />;
    }
    // Prevent going back to record page
    window.history.pushState(null, "", "/verification-success");
    window.addEventListener("popstate", () => {
      navigate("/", { replace: true });
    });
  }

  // Protect other routes
  if (
    !hasValidToken &&
    (location.pathname === "/record" || location.pathname === "/consent-form")
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
